// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Zf5k","messages":"Chat_messages__25iIk","dateDivider":"Chat_dateDivider__3HjNV"};